import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const DeleteJobTitleModalLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "DeleteJobTitleModal" */
      './DeleteJobTitleModal'
    ),
  loading: LoadingModal,
});
